import React from 'react';

const PALETTES = [
  { accent: '#90a78d', light: '#d9e3cb', second: '#d6a783', soft: '#f0dfbb' },
  { accent: '#8ca7b4', light: '#d4e3e7', second: '#bd9eac', soft: '#e9dbca' },
  { accent: '#ba9386', light: '#eddbd1', second: '#9aab8b', soft: '#ede4c4' },
  { accent: '#aca0b7', light: '#e3dbe9', second: '#d5ad75', soft: '#f1e5cd' },
];
const INK = '#776958';
const WOOD = '#ba936d';
const WOOD_DARK = '#947355';
const PAPER = '#f7efdb';

function Ground() {
  return <><ellipse cx="160" cy="187" rx="137" ry="14" fill="#4d514a" opacity=".09" /><ellipse cx="161" cy="185" rx="109" ry="8" fill="#4d514a" opacity=".08" /></>;
}

function Table({ y = 128, width = 250 }) {
  const x = (320 - width) / 2;
  return <g>
    <path d={`M${x + 20} ${y + 9}l-5 49h10l9-49M${x + width - 30} ${y + 9}l7 49h10l-4-49`} fill={WOOD_DARK} />
    <path d={`M${x + 4} ${y - 11}h${width - 8}l10 19H${x - 6}z`} fill="#d8b48a" stroke={WOOD_DARK} strokeWidth="2.6" strokeLinejoin="round" />
    <rect x={x - 6} y={y + 4} width={width + 12} height="10" rx="4" fill={WOOD} />
    <path d={`M${x + 9} ${y + 7}h${width - 18}`} stroke="#dfbf95" strokeWidth="2" strokeLinecap="round" />
  </g>;
}

function Book({ x, y, width = 48, color = '#91a68d', angle = 0 }) {
  return <g transform={`translate(${x} ${y}) rotate(${angle})`}>
    <rect width={width} height="15" rx="3" fill={color} />
    <path d={`M8 3h${width - 11}v9H8z`} fill={PAPER} />
    <path d={`M12 6h${width - 19}M12 9h${width - 19}`} stroke="#d7cbb2" strokeWidth="1" />
  </g>;
}

function Paper({ x, y, width = 42, height = 50, angle = 0, color = PAPER }) {
  return <g transform={`translate(${x} ${y}) rotate(${angle})`}>
    <rect x="2" y="3" width={width} height={height} rx="3" fill="#685c4b" opacity=".08" />
    <rect width={width} height={height} rx="3" fill={color} stroke="#cbbb9e" strokeWidth="1.5" />
    <path d={`M8 12h${width - 16}M8 20h${width - 16}M8 28h${width - 20}M8 36h${width - 24}`} fill="none" stroke="#c8baa1" strokeWidth="1.8" strokeLinecap="round" />
  </g>;
}

function Plant({ x, y, color = '#99ad87', scale = 1 }) {
  return <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <path d="M0 12V-22M0-8C-16-9-20-21-16-26-3-25 2-17 0-8M1-17c13-3 20-15 15-21C3-35-1-28 1-17" fill={color} stroke="#71886b" strokeWidth="2" strokeLinejoin="round" />
    <path d="M-15 7h30l-4 23h-22z" fill="#ceaa8d" stroke="#a38265" strokeWidth="2" />
    <rect x="-18" y="4" width="36" height="8" rx="3" fill="#d9b99b" stroke="#a38265" strokeWidth="2" />
  </g>;
}

function Cup({ x, y, color = '#c4d3bc', scale = 1 }) {
  return <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <ellipse cx="0" cy="14" rx="18" ry="4" fill="#b3a183" opacity=".38" />
    <path d="M10-7c18-3 17 15 0 14" fill="none" stroke={INK} strokeWidth="3" />
    <path d="M-13-10h26l-2 20c-5 6-16 6-22 0z" fill={color} stroke={INK} strokeWidth="2" />
    <ellipse cy="-10" rx="13" ry="4" fill={PAPER} stroke={INK} strokeWidth="2" />
    <ellipse cy="-10" rx="9" ry="2" fill="#b49b7b" />
  </g>;
}

function OpenBook({ x, y, width = 88, accent }) {
  return <g transform={`translate(${x} ${y}) scale(${width / 88})`}>
    <path d="M0 7c14-9 31-7 44 0 13-7 30-9 44 0v33c-13-7-31-7-44 0-13-7-31-7-44 0z" fill={accent} stroke={INK} strokeWidth="2" strokeLinejoin="round" />
    <path d="M3 3c12-6 29-4 41 3 12-7 29-9 41-3v31c-13-6-28-5-41 2-13-7-28-8-41-2z" fill={PAPER} stroke="#cbbb9e" strokeWidth="1.4" />
    <path d="M44 7v28M10 12l24 2M10 19l24 2M10 26l24 2M54 14l24-2M54 21l24-2M54 28l24-2" fill="none" stroke="#c4b598" strokeWidth="1.5" strokeLinecap="round" />
  </g>;
}

function Nursery({ p, variant }) {
  return <g>
    <path d="M44 172c31-18 183-22 234-2l-18 19H56z" fill={p.light} opacity=".95" />
    <path d="M69 143h45v38H69zM69 143l11-10h44l-10 10M114 143l10-10v37l-10 11" fill={p.accent} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M78 156h27v14H78z" fill={p.light} opacity=".9" />
    <path d="M112 109h43v39h-43zM112 109l10-9h43l-10 9M155 109l10-9v39l-10 9" fill={p.second} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <circle cx="134" cy="129" r="9" fill={p.soft} />
    <path d="M127 151h42v31h-42zM127 151l10-9h42l-10 9M169 151l10-9v30l-10 10" fill="#e1bd7d" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <path d="m139 173 8-15 9 15z" fill={PAPER} />
    <path d="M204 176c-25-10-30-31-15-42 11-8 26-2 29 8 20-17 37-7 35 9-1 16-22 27-49 25" fill={p.light} stroke={INK} strokeWidth="2.5" />
    <path d="m204 136-1-33c0-14 13-16 18-4l9 26" fill={p.light} stroke={INK} strokeWidth="2.5" />
    <path d="m222 124 13-5 17 15-4 13-22-1" fill={p.light} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <path d="m216 106-4-13 12 9" fill={p.second} stroke={INK} strokeWidth="2" strokeLinejoin="round" />
    <circle cx="236" cy="131" r="2.7" fill={INK} />
    <path d="M184 180c21 15 57 15 78-2" fill="none" stroke={WOOD_DARK} strokeWidth="7" strokeLinecap="round" />
    <path d="m202 163-5 22m41-23 6 21" stroke={WOOD_DARK} strokeWidth="5" strokeLinecap="round" />
    <circle cx={variant % 2 ? 54 : 276} cy="168" r="12" fill={p.second} stroke={INK} strokeWidth="2" />
    <path d={variant % 2 ? 'M47 158c0 13 5 18 16 19' : 'M269 158c0 13 5 18 16 19'} fill="none" stroke={PAPER} strokeWidth="3" />
  </g>;
}

function School({ p }) {
  return <g>
    <path d="M211 170v-43c0-29 53-30 53 0v43" fill={p.accent} stroke={INK} strokeWidth="2.7" />
    <path d="M218 113c-7-33 44-33 39 0M210 144h55" fill="none" stroke={INK} strokeWidth="3" />
    <rect x="216" y="141" width="44" height="35" rx="10" fill={p.light} stroke={INK} strokeWidth="2.5" />
    <path d="M222 151h31M237 151v5" stroke={INK} strokeWidth="2" strokeLinecap="round" />
    <path d="M53 130v55m127-55v55" stroke={WOOD_DARK} strokeWidth="9" strokeLinecap="round" />
    <path d="M43 118h145l8 15H36z" fill="#d9b58a" stroke={WOOD_DARK} strokeWidth="2.5" strokeLinejoin="round" />
    <rect x="37" y="131" width="158" height="11" rx="3" fill={WOOD} />
    <path d="M64 145h103v15H64z" fill="#c29d77" stroke={WOOD_DARK} strokeWidth="2" />
    <circle cx="117" cy="152" r="2.2" fill={WOOD_DARK} />
    <Book x={69} y={107} width={67} color={p.accent} angle={-3} />
    <path d="m143 113 32-32 6 6-32 32-10 4z" fill="#e5c77f" stroke={INK} strokeWidth="1.6" strokeLinejoin="round" />
    <path d="m143 113 6 6-10 4z" fill={PAPER} /><path d="m139 123 3-5 2 2z" fill={INK} />
    <path d="M53 93h13l3 25H50z" fill={p.second} stroke={INK} strokeWidth="2" />
    <path d="M56 93V74m5 19 6-23" stroke="#a2a77a" strokeWidth="4" strokeLinecap="round" />
  </g>;
}

function Study({ p }) {
  return <g>
    <path d="M126 132v-46c0-18 67-18 67 0v46" fill={p.light} stroke={INK} strokeWidth="3" />
    <Table />
    <path d="M71 114h44M93 113V77l23-30" fill="none" stroke={INK} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m102 47 29-15 18 25-38 17z" fill={p.accent} stroke={INK} strokeWidth="2.7" strokeLinejoin="round" />
    <path d="m113 73 34-15" stroke={PAPER} strokeWidth="4" strokeLinecap="round" />
    <OpenBook x={129} y={90} width={84} accent={p.accent} />
    <Book x={220} y={107} width={47} color={p.second} angle={-2} />
    <Book x={224} y={94} width={44} color={p.accent} angle={3} />
    <path d="m201 123 16-17" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    <Plant x={63} y={89} scale={.62} color={p.accent} />
  </g>;
}

function Research({ p }) {
  return <g>
    <Table />
    <Paper x={205} y={71} width={42} height={52} angle={8} />
    <Paper x={217} y={65} width={43} height={52} angle={-3} />
    <path d="M67 52v25l-22 34c-4 7 1 12 9 12h46c8 0 13-5 9-12L87 77V52" fill="#e4ece1" stroke={INK} strokeWidth="2.8" strokeLinejoin="round" />
    <path d="m58 99-7 13c-2 3 0 5 4 5h44c4 0 6-2 4-5l-7-13z" fill={p.accent} />
    <path d="M64 52h26M66 45h22" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    <circle cx="72" cy="106" r="2.5" fill={p.light} /><circle cx="87" cy="111" r="3" fill={p.light} />
    <path d="M123 67v44c0 17 22 17 22 0V67M153 67v44c0 17 22 17 22 0V67" fill="#e6ece2" stroke={INK} strokeWidth="2.5" />
    <path d="M126 91v19c0 13 16 13 16 0V91z" fill={p.second} /><path d="M156 83v27c0 13 16 13 16 0V83z" fill={p.accent} />
    <path d="M117 78h65v7h-65zM121 83v40m56-40v40M116 124h67" fill={WOOD} stroke={WOOD_DARK} strokeWidth="3" strokeLinecap="round" />
    <path d="M126 62h16m14 0h16" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    <path d="m186 108 7-38 12 3-7 38z" fill={p.light} stroke={INK} strokeWidth="2" />
    <path d="m192 78 9 2m-10 6 9 2m-10 6 9 2" stroke={INK} strokeWidth="1.5" />
  </g>;
}

function Studio({ p }) {
  return <g>
    <Table />
    <path d="M174 121 198 26h7l22 96M201 91v30" fill="none" stroke={WOOD_DARK} strokeWidth="5" strokeLinecap="round" />
    <rect x="166" y="42" width="73" height="63" rx="3" fill={PAPER} stroke={WOOD_DARK} strokeWidth="3" />
    <path d="M173 92c13-24 17-8 27-23s21-13 32 3v25h-59z" fill={p.light} /><circle cx="216" cy="58" r="8" fill={p.soft} />
    <path d="M161 108h83" stroke={WOOD_DARK} strokeWidth="5" strokeLinecap="round" />
    <path d="M77 86c-27 4-42 25-23 36 13 7 31 1 45 3 24 5 43-15 27-28-5-4-13 3-17-2-6-8-20-11-32-9" fill="#d9b78a" stroke={INK} strokeWidth="2.3" />
    <ellipse cx="111" cy="107" rx="8" ry="5" fill="#a38a69" />
    <circle cx="65" cy="108" r="6" fill={p.accent} /><circle cx="77" cy="98" r="6" fill={p.second} /><circle cx="93" cy="99" r="5" fill="#e2c57d" />
    <path d="M131 118 145 68l5 2-13 49z" fill={WOOD_DARK} /><path d="m143 73 1-17 10-4-5 20z" fill={p.accent} stroke={INK} strokeWidth="1.7" />
    <path d="M247 89h23l-3 31h-17z" fill={p.light} stroke={INK} strokeWidth="2" />
    <path d="m254 88-6-29m12 29 7-39m-4 39 11-24" stroke={WOOD_DARK} strokeWidth="3.2" strokeLinecap="round" />
  </g>;
}

function Kitchen({ p }) {
  return <g>
    <path d="M45 128h229v55H45z" fill={p.light} stroke={INK} strokeWidth="2.5" />
    <path d="M51 137h68v40H51zm75 0h65v40h-65zm72 0h69v40h-69z" fill={p.accent} opacity=".55" />
    <path d="M60 145h23m62 0h23m49 0h23" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    <path d="M38 116h243v16H38z" fill="#d6b28b" stroke={WOOD_DARK} strokeWidth="2.5" strokeLinejoin="round" />
    <ellipse cx="117" cy="112" rx="45" ry="8" fill={INK} opacity=".15" />
    <path d="M85 73h64v33c-2 15-61 15-64 0z" fill={p.accent} stroke={INK} strokeWidth="2.6" />
    <path d="M84 81H72v17h13m65-17h12v17h-13" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M80 73c13-17 61-17 74 0z" fill={p.light} stroke={INK} strokeWidth="2.5" /><path d="M107 60v-6h20v6" fill="none" stroke={INK} strokeWidth="3" strokeLinejoin="round" />
    <rect x="181" y="101" width="73" height="17" rx="7" fill="#c8a376" stroke={WOOD_DARK} strokeWidth="2" />
    <path d="m204 109 10-25 7 4-9 24z" fill="#d8a174" stroke={INK} strokeWidth="1.6" /><path d="m215 86-6-10m9 9 6-12m-4 15 12-4" stroke="#8b9f74" strokeWidth="3" strokeLinecap="round" />
    <circle cx="239" cy="103" r="11" fill={p.second} stroke={INK} strokeWidth="2" /><path d="m234 92 5 6 5-6m-5 6 1-11" stroke="#82956f" strokeWidth="2" strokeLinecap="round" />
    <path d="M54 106V58l20 3-4 46" fill={PAPER} stroke={INK} strokeWidth="2" strokeLinejoin="round" /><path d="M57 76h15m-16 9h15" stroke={p.accent} strokeWidth="3" />
  </g>;
}

function Code({ p }) {
  return <g>
    <Table />
    <path d="M173 46h85v60h-85z" fill={INK} stroke={INK} strokeWidth="5" strokeLinejoin="round" />
    <rect x="177" y="50" width="77" height="49" rx="3" fill={p.light} />
    <path d="M215 107v12m-18 1h36" stroke={INK} strokeWidth="5" strokeLinecap="round" />
    <path d="m192 65-6 7 6 7m43-14 6 7-6 7m-18-17-7 23" fill="none" stroke={p.accent} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="62" y="67" width="101" height="58" rx="5" fill={p.accent} stroke={INK} strokeWidth="3" />
    <rect x="68" y="73" width="89" height="44" rx="2" fill="#e7ecdf" />
    <path d="M77 83h26m7 0h15m-48 9h42m-35 9h33m-33 8h47" stroke={p.accent} strokeWidth="3" strokeLinecap="round" />
    <path d="M59 123h107l13 10H46z" fill={p.light} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" /><path d="M95 126h33l3 4H92z" fill={p.accent} />
    <Cup x={270} y={105} color={p.second} scale={.68} />
    <path d="M184 126c-4 3-6 8-4 11 3 4 10 4 14 0 2-3 1-7-3-11z" fill={p.accent} stroke={INK} strokeWidth="1.6" />
  </g>;
}

function Music({ p }) {
  return <g>
    <path d="M99 176 80 186m19-10 19 10m-19-10v-27" fill="none" stroke={WOOD_DARK} strokeWidth="5" strokeLinecap="round" />
    <path d="M98 178c-35 0-51-33-33-54 5-7 14-10 14-21 0-16 35-16 35 0 0 11 9 14 15 21 17 21 3 54-31 54" fill="#d8ad78" stroke={INK} strokeWidth="3" />
    <path d="M87 101 91 37h13l7 64" fill={WOOD_DARK} stroke={INK} strokeWidth="2" />
    <path d="m89 38-2-20 20-1 2 21z" fill={p.accent} stroke={INK} strokeWidth="2" strokeLinejoin="round" />
    <path d="M86 22h-5m6 8h-5m27-9h5m-4 9h5" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    <circle cx="98" cy="123" r="15" fill="#8c7056" stroke="#efcf9f" strokeWidth="4" />
    <path d="M85 151h27" stroke={WOOD_DARK} strokeWidth="8" strokeLinecap="round" />
    <path d="M95 24v130m3-130v130m3-130v130" stroke={PAPER} strokeWidth=".85" opacity=".9" />
    <path d="M214 126v51m0-1-31 10m31-10 31 10" stroke={INK} strokeWidth="5" strokeLinecap="round" />
    <path d="M174 66h83l9 64h-99z" fill={p.accent} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <Paper x={182} y={62} width={40} height={59} angle={-3} />
    <Paper x={218} y={60} width={33} height={59} angle={4} />
    <path d="M174 131h87" stroke={WOOD_DARK} strokeWidth="5" strokeLinecap="round" />
    <path d="M196 80v15c-9-4-11 7-3 7 5 0 6-3 6-7V78l12-3v17c-9-3-11 7-3 7 5 0 6-3 6-7V72z" fill={INK} opacity=".8" />
    <Book x={252} y={170} width={34} color={p.second} angle={-6} />
  </g>;
}

function Writing({ p }) {
  return <g>
    <Table />
    <Book x={49} y={108} width={55} color={p.second} angle={-4} />
    <Book x={53} y={95} width={52} color={p.accent} angle={2} />
    <Paper x={120} y={63} width={57} height={61} angle={-8} />
    <Paper x={139} y={64} width={55} height={61} angle={3} />
    <path d="m179 121 40-52 7 6-39 52-13 5z" fill={p.accent} stroke={INK} strokeWidth="2" strokeLinejoin="round" />
    <path d="m179 121 8 6-13 5z" fill={PAPER} /><path d="m174 132 3-6 3 2z" fill={INK} />
    <path d="m219 69 4-5c4-4 11 2 8 6l-5 5" fill={p.second} stroke={INK} strokeWidth="2" />
    <Cup x={253} y={105} color={p.light} scale={.8} />
    <path d="M220 118h15v-14l-3-5h-9l-3 5z" fill="#8d9b8d" stroke={INK} strokeWidth="2" /><rect x="222" y="95" width="11" height="5" rx="1" fill={INK} />
    <path d="m139 116 5 15 7-13" fill={p.second} />
  </g>;
}

function Finance({ p }) {
  return <g>
    <Table />
    <path d="M56 74h86v48H56z" fill={p.accent} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <OpenBook x={59} y={71} width={81} accent={p.accent} />
    <path d="M66 94h24m10-1h29M66 102h24m10-1h29M78 84v27m34-27v27" stroke="#b7aa8e" strokeWidth="1.2" />
    <g transform="translate(161 59) rotate(7)">
      <rect width="58" height="69" rx="7" fill={p.accent} stroke={INK} strokeWidth="2.5" />
      <rect x="8" y="9" width="42" height="15" rx="2" fill="#dce4cf" stroke={INK} strokeWidth="1.5" />
      {[0, 1, 2].map((row) => [0, 1, 2].map((col) => <rect key={`${row}-${col}`} x={9 + col * 15} y={32 + row * 10} width="10" height="6" rx="1.5" fill={row === 2 && col === 2 ? p.second : PAPER} />))}
    </g>
    {[0, 1, 2].map((i) => <g key={i} transform={`translate(${241 + i * 12} ${118 - i * 2})`}>
      <path d="M-12-6v6c0 5 24 5 24 0v-6" fill="#c4a16a" stroke="#9c865f" strokeWidth="1.6" />
      <ellipse cy="-6" rx="12" ry="4" fill="#e5cd91" stroke="#9c865f" strokeWidth="1.6" />
      <ellipse cy="-6" rx="7" ry="1.5" fill="none" stroke="#c4a16a" strokeWidth="1" />
    </g>)}
    <path d="m120 122 28-20" stroke={INK} strokeWidth="3" strokeLinecap="round" />
  </g>;
}

function Office({ p }) {
  return <g>
    <path d="M164 111h103v65H164z" fill={p.accent} stroke={INK} strokeWidth="2.8" strokeLinejoin="round" />
    <path d="M192 112V98c0-9 47-9 47 0v14" fill="none" stroke={INK} strokeWidth="5" strokeLinecap="round" />
    <path d="M164 123c25 20 78 20 103 0" fill={p.light} stroke={INK} strokeWidth="2.5" />
    <rect x="207" y="132" width="17" height="12" rx="3" fill={p.soft} stroke={INK} strokeWidth="2" />
    <path d="M57 83h82v91H57z" fill="#d0b28c" stroke={INK} strokeWidth="2.5" />
    <Paper x={68} y={54} width={53} height={85} angle={-5} />
    <Paper x={84} y={51} width={48} height={83} angle={5} />
    <path d="M50 106h39l10 12h47l-11 60H61z" fill={p.light} stroke={INK} strokeWidth="2.7" strokeLinejoin="round" />
    <path d="M63 130h68m-66 10h45" stroke={p.accent} strokeWidth="3" strokeLinecap="round" />
    <Book x={200} y={178} width={72} color={p.second} angle={0} />
    <path d="m145 166 10-36 6 2-9 36-6 7z" fill={p.second} stroke={INK} strokeWidth="1.6" strokeLinejoin="round" />
  </g>;
}

function Service({ p }) {
  return <g>
    <path d="M53 116h215v68H53z" fill={p.light} stroke={INK} strokeWidth="2.5" />
    <path d="M62 133h197v41H62z" fill={p.accent} opacity=".6" /><path d="M70 142h181M70 165h181" stroke={PAPER} strokeWidth="2" opacity=".45" />
    <path d="M43 109h235v15H43z" fill="#d7b58b" stroke={WOOD_DARK} strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M92 104c1-35 49-35 51 0z" fill={p.soft} stroke={INK} strokeWidth="2.5" />
    <path d="M87 108h61" stroke={WOOD_DARK} strokeWidth="6" strokeLinecap="round" />
    <path d="M116 80v-8m-5 0h10" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    <path d="M105 88c-6 2-9 6-11 10" fill="none" stroke={PAPER} strokeWidth="3" strokeLinecap="round" />
    <rect x="176" y="45" width="58" height="62" rx="5" fill={p.accent} stroke={INK} strokeWidth="2.5" />
    <Paper x={182} y={51} width={46} height={50} />
    <rect x="196" y="41" width="20" height="10" rx="3" fill={INK} />
    <Plant x={252} y={88} scale={.57} color={p.accent} />
    <path d="M155 104h12V84h-12z" fill={p.second} stroke={INK} strokeWidth="1.8" /><path d="m159 84-3-18m7 18 4-22" stroke={WOOD_DARK} strokeWidth="2.5" strokeLinecap="round" />
  </g>;
}

function Community({ p }) {
  return <g>
    <path d="M133 89V65c0-17 51-17 51 0v24" fill={p.accent} stroke={INK} strokeWidth="3" />
    <path d="M138 89V73h41v16" fill={p.light} opacity=".75" />
    <path d="M94 139v41m130-41v41M117 143l-6 43m91-43 6 43" stroke={WOOD_DARK} strokeWidth="8" strokeLinecap="round" />
    <ellipse cx="159" cy="120" rx="98" ry="28" fill={WOOD} stroke={WOOD_DARK} strokeWidth="2.5" />
    <ellipse cx="159" cy="113" rx="98" ry="28" fill="#d9b68f" stroke={WOOD_DARK} strokeWidth="2.5" />
    <ellipse cx="159" cy="112" rx="86" ry="21" fill="none" stroke="#e4c8a4" strokeWidth="2" />
    <Cup x={113} y={106} color={p.light} scale={.64} />
    <Cup x={206} y={112} color={p.second} scale={.64} />
    <path d="M158 108V84m0 11c-11 2-17-5-16-11 12-2 18 6 16 11m1-5c10 1 15-6 12-11-10 0-14 6-12 11" fill={p.accent} stroke="#7d916f" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M148 106h20l-3 14h-14z" fill={PAPER} stroke={INK} strokeWidth="1.7" />
    <path d="M42 142v38m44-38v38" stroke={WOOD_DARK} strokeWidth="6" strokeLinecap="round" />
    <path d="M36 137v-27c0-18 57-18 57 0v27" fill={p.accent} stroke={INK} strokeWidth="3" />
    <path d="M35 139h59" stroke={WOOD_DARK} strokeWidth="7" strokeLinecap="round" />
    <path d="M236 149v34m42-34v34" stroke={WOOD_DARK} strokeWidth="6" strokeLinecap="round" />
    <path d="M229 145v-27c0-18 57-18 57 0v27" fill={p.second} stroke={INK} strokeWidth="3" />
    <path d="M229 147h57" stroke={WOOD_DARK} strokeWidth="7" strokeLinecap="round" />
  </g>;
}

function Garden({ p }) {
  return <g>
    <path d="M75 121V51m0 32C48 80 39 58 47 49c23-1 35 19 28 34m1-18c27-3 37-25 27-35-23 2-33 19-27 35m-1 45C51 111 40 91 45 82c23-5 35 13 30 28m2-15c22 2 37-16 32-27-23-5-39 10-32 27" fill={p.accent} stroke="#718669" strokeWidth="2.3" strokeLinejoin="round" />
    <path d="M43 126h65l-8 54H52z" fill="#c3a080" stroke={INK} strokeWidth="2.5" /><rect x="38" y="119" width="75" height="14" rx="4" fill="#d7b394" stroke={INK} strokeWidth="2.5" />
    <path d="M141 147v-35m-1 13c-17-2-22-17-16-23 16 1 23 13 16 23m2-8c17 1 25-14 19-21-17-1-24 12-19 21" fill={p.light} stroke="#7d916f" strokeWidth="2" strokeLinejoin="round" />
    <path d="M121 148h42l-5 34h-32z" fill={p.second} stroke={INK} strokeWidth="2.2" /><rect x="117" y="142" width="50" height="10" rx="3" fill="#e0c2a6" stroke={INK} strokeWidth="2.2" />
    <path d="M205 131c-34-36 36-47 42-12" fill="none" stroke={p.accent} strokeWidth="9" /><path d="M205 131c-34-36 36-47 42-12" fill="none" stroke={INK} strokeWidth="2" />
    <path d="M198 127h49v47c0 9-49 9-49 0z" fill={p.accent} stroke={INK} strokeWidth="2.5" /><ellipse cx="223" cy="127" rx="24" ry="7" fill={p.light} stroke={INK} strokeWidth="2.5" />
    <path d="m247 153 27-26 8 10-35 29" fill={p.accent} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <path d="m271 125 10-6 12 16-10 6z" fill={p.light} stroke={INK} strokeWidth="2" strokeLinejoin="round" />
    <path d="m277 126 6 8m-2-11 6 8" stroke={INK} strokeWidth="1.4" strokeLinecap="round" />
    <path d="M207 144v21" stroke={p.light} strokeWidth="4" strokeLinecap="round" opacity=".7" />
  </g>;
}

function Medical({ p }) {
  return <g>
    <Table />
    <Paper x={202} y={59} width={48} height={61} angle={7} />
    <path d="M212 69h27m-22 0 4-5 4 9 4-8 3 4" stroke={p.accent} strokeWidth="2" strokeLinecap="round" />
    <rect x="54" y="67" width="91" height="57" rx="10" fill={p.light} stroke={INK} strokeWidth="2.8" />
    <path d="M77 67V54c0-11 43-11 43 0v13" stroke={INK} strokeWidth="5" />
    <path d="M55 80h89" stroke={p.accent} strokeWidth="3" />
    <path d="M92 85h14v9h9v14h-9v9H92v-9h-9V94h9z" fill={p.second} />
    <path d="M164 63v15c0 18 27 18 27 0V63m-27 0-4-11m31 11 4-11" stroke={p.accent} strokeWidth="5" />
    <path d="M175 92v11c0 24 28 25 28 6" stroke={INK} strokeWidth="3.5" />
    <circle cx="203" cy="105" r="8" fill={p.light} stroke={INK} strokeWidth="2.5" /><circle cx="203" cy="105" r="3" fill={p.accent} />
    <path d="m160 52-3-5m38 5 3-5" stroke={INK} strokeWidth="4" />
    <path d="M255 98h17v25h-17z" fill={PAPER} stroke={INK} strokeWidth="2" /><rect x="258" y="92" width="11" height="7" rx="2" fill={p.accent} />
    <path d="M259 110h9m-4-4v9" stroke={p.accent} strokeWidth="2" />
  </g>;
}

function Public({ p }) {
  return <g>
    <Table />
    <Paper x={206} y={62} width={47} height={59} angle={5} />
    <path d="m221 77 5 3 5-3v10c-1 4-5 6-5 6s-4-2-5-6z" fill={p.accent} stroke={INK} strokeWidth="1.2" />
    <path d="M48 106c0-51 69-51 69 0z" fill={p.accent} stroke={INK} strokeWidth="2.8" />
    <path d="M76 76v23m10-24v24" stroke={p.light} strokeWidth="4" />
    <path d="M42 108h82v9H42z" fill={p.light} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M55 120c5 13 36 14 47 0" stroke={INK} strokeWidth="2.5" />
    <rect x="143" y="60" width="42" height="64" rx="7" fill={p.accent} stroke={INK} strokeWidth="2.5" />
    <path d="M150 60V36m24 24V48" stroke={INK} strokeWidth="5" />
    <rect x="150" y="68" width="28" height="15" rx="3" fill={p.light} stroke={INK} strokeWidth="1.5" />
    <path d="M152 93h24m-24 6h24m-24 6h24" stroke={INK} strokeWidth="2" /><circle cx="164" cy="115" r="3.5" fill={p.second} />
    <path d="m257 115 8-28 10 3-7 28z" fill={p.second} stroke={INK} strokeWidth="2" />
    <path d="m264 88 3-10 11 3-3 10" fill={p.light} stroke={INK} strokeWidth="2" />
  </g>;
}

const ART = {
  nursery: Nursery,
  school: School,
  study: Study,
  research: Research,
  studio: Studio,
  kitchen: Kitchen,
  code: Code,
  music: Music,
  writing: Writing,
  finance: Finance,
  office: Office,
  service: Service,
  community: Community,
  garden: Garden,
  medical: Medical,
  public: Public,
};

/** 실제 활동과 연결하는 장면 소품. 출생 풍경과 동물의 계산에는 관여하지 않는다. */
export default function SceneProps({ kind, variant = 0 }) {
  const index = Number.isFinite(Number(variant)) ? Math.abs(Math.trunc(Number(variant))) : 0;
  const p = PALETTES[index % PALETTES.length];
  const Art = Object.prototype.hasOwnProperty.call(ART, kind) ? ART[kind] : Study;
  return <svg viewBox="0 0 320 210" preserveAspectRatio="xMidYMax meet" className="scene-prop-art" aria-hidden="true" focusable="false" fill="none" strokeLinecap="round" strokeLinejoin="round">
    <Ground />
    <Art p={p} variant={index} />
  </svg>;
}
